"use strict";

$(document).ready(function () {
    $(".slkCarousel").slick({
        prevArrow: ".slick-prev",
        nextArrow: ".slick-next",
        appendDots: ".slkCarouselNav",
        dots: true,
    });
});


// Variable initialisation
var cType = 1;  // Primary concrete type (ID)
var sType = 0;  // Primary steel type (ID)
var data = {mat: {}, geo: {}, cl: {}, plot: {}}; // Data Struct containing all informations about materials, geometry, calculations, plots
var init = 0; // Flag variable if all plots etc are initialised (1) or not (0)
var q = 50;
var alpha = 40;


// Initialise Sliders
var sldAlpha = document.getElementById('sfAlpha');

noUiSlider.create(sldAlpha, {
    start: [40],
    range: {
        'min': 30,
        'max': 45
    },
    tooltips: true,
    step: 0.5,
    pips: {
        mode: 'count',
        values: 4,
        density: 7
    },
    format: {
        to: function(value){
            return (Math.round(value * 2) / 2).toFixed(1);
        },
        from: function(value){
            return value;
        }
    }
});

sldAlpha.noUiSlider.on('slide', updateAlpha);

function updateAlpha(values, handle, unencoded, tap, positions){
    alpha = (Math.round(values[0] * 2) / 2).toFixed(1);
    
    updCalc();
}

var sldQ = document.getElementById('slQ');

noUiSlider.create(sldQ, {
    start: [50],
    range: {
        'min': 0,
        'max': 100
    },
    tooltips: true,
    step: 1,
    pips: {
        mode: 'count',
        values: 11,
        density: 5
    },
    format: {
        to: function(value){
            return Math.round(value);
        },
        from: function(value){
            return value;
        }
    }
});

sldQ.noUiSlider.on('slide', updateQ);

function updateQ(values, handle, unencoded, tap, positions){
    q = Math.round(values[0]);
    updCalc();
}

$('#mzLine').change(function(){
    updCalc();
});

// Init call
updCalc();

var l, h, xf, V, M, Av, Bv, x, alpha, vSwitch;

function updCalc() {
    // Initialisation of variables
    l = 10; // [m]
    h = 1.4; // [m]

    //Refresh values...
    document.getElementById('qact').innerHTML = q;
    document.getElementById('alpha').innerHTML = alpha;


    //View Mode...
    vSwitch = document.querySelector('input[name="view"]:checked').id;

    // Auflagerkräfte berechnen
    Bv = (q * l) / 2;
    Av = Bv;

    // Schnittkräfte berechnen
    V = [[0, 0, l, l], [0, -Av, Bv, 0]];
    x = math.range(0, l*(1+1/1000), l/2000); //Abstandsvektor
    M = math.zeros(x._data.length); //Fill up moment vector with zeros

    for (let o = 0; o < x._data.length - 1; o++) {
        M._data[o] = q*x._data[o]*x._data[o]/2 - Av * x._data[o];
    }

    // Nullpunktdurchgang Querkraft
    let xv0 = l/2;

    // Calculate stress fields...
    let xSf, xSfr, nPf;

    // Länge einzelner Fächer (Höhe Fächer festgelegt auf h-0.2m)
    xSf = Math.round((h-0.2)/Math.tan(alpha/180*Math.PI)*1000)/1000;

    // Anzahl Parallelfelder bis Querkraftnullpunkt Links / Rechts
    nPf = Math.floor(xv0/xSf);

    // Restliche Länge letztes Feld...
    xSfr = xv0-nPf*xSf;

    // ***** Calculate structure plot
    let stPlt;
    stPlt = new Group();

    // Concrete Structure
    let cSt = new Group();
    cSt.addElm(new Rectangle(l, h, l/2, h/2).setFill(col.c_vis.getRgba()));
    cSt.addElm(new Support(0,0,1,0.25));
    cSt.addElm(new Text(-0.1,0,'A'));
    cSt.addElm(new Support(l,0,2,0.25));
    cSt.addElm(new Text(l+0.1,0,'B'));
    stPlt.addElm(cSt);

    // Plot Forces...
    let fGrp = new Group();
    if (q>0) {
        fGrp.addElm(new DistForce(0,h,l,h,q/100,0.4));
    }
    stPlt.addElm(fGrp);

    // ****** Plot Spannungsfelder

    if(vSwitch === 'sp' || vSwitch === 'both'){
        let spfL = new Group();
        spfL.addElm(new Fan(0,0.1,h-0.2,alpha));
        for ( let i=0; i < (nPf-1); i++ ) {
            spfL.addElm(new ParallelField(i*xSf,0.1,h-0.2,alpha));
        }
        spfL.addElm(new ParallelField([(nPf-1)*xSf, nPf*xSf, nPf*xSf+xSfr, nPf*xSf],[0.1, h-0.1, h-0.1, 0.1]));
        stPlt.addElm(spfL);

        let spfR = new Group();
        spfR.addElm(new Fan(l,0.1,h-0.2,-alpha));
        for ( let i=0; i < (nPf-1); i++ ) {
            spfR.addElm(new ParallelField(l-i*xSf,0.1,h-0.2,-alpha));
        }
        spfR.addElm(new ParallelField([l-(nPf-1)*xSf, l-nPf*xSf, l-(nPf*xSf+xSfr), l-nPf*xSf],[0.1, h-0.1, h-0.1, 0.1]));
        stPlt.addElm(spfR);
    }

    // FWM
    // Berechnung Gurt und Bügelkräfte mit anschliessendem Plot...
    const FWMnodes = [];
    const FWMstruts = [];
    const FWMsupports = [];
    const FWMforces = [];
    const nodeIdUpperStrut = [];
    const nodeIdLowerStrut = [];

    // Define nodes...
    let x0 = 0;
    let y0 = 0.1;

    // Untergurt...
    FWMnodes.push({x: x0, y: y0});
    nodeIdLowerStrut.push(FWMnodes.length-1);

    for (let i=0; i<nPf; i++) {
        FWMnodes.push({x: x0+xSf/2+i*xSf, y: y0});
        nodeIdLowerStrut.push(FWMnodes.length-1);
    }

    // Knoten mittig (für Nullstäbe)
    let tmpX = x0 + xv0;
    FWMnodes.push({x: tmpX, y: y0});
    nodeIdLowerStrut.push(FWMnodes.length-1);

    for (let i = nPf-1; i>=0; i--) {
        FWMnodes.push({x: x0+(l-(xSf/2+i*xSf)), y: y0});
        nodeIdLowerStrut.push(FWMnodes.length-1);
    }

    FWMnodes.push({x: x0+l, y: y0});
    nodeIdLowerStrut.push(FWMnodes.length-1);

    // Obergurt...
    for (let i=0; i < (nPf); i++) {
        FWMnodes.push({x: x0+xSf/2+i*xSf, y: y0+h-0.2});
        nodeIdUpperStrut.push(FWMnodes.length-1);
    }

    FWMnodes.push({x: x0+(nPf)*xSf+0.5*xSfr, y: y0+h-0.2});
    nodeIdUpperStrut.push(FWMnodes.length-1);

    FWMnodes.push({x: x0+l-((nPf)*xSf+0.5*xSfr), y: y0+h-0.2});
    nodeIdUpperStrut.push(FWMnodes.length-1);

    for (let i = (nPf-1); i>=0; i--) {
        FWMnodes.push({x: x0+l-(xSf/2+i*xSf), y: y0+h-0.2});
        nodeIdUpperStrut.push(FWMnodes.length-1);
    }

    // *** Define struts
    // Gurte
    for (let i=0; i < nodeIdLowerStrut.length-1; i++) {
        FWMstruts.push({node1: i, node2: i+1});
    }

    for (let i=0; i < nodeIdUpperStrut.length-1; i++) {
        FWMstruts.push({node1: nodeIdUpperStrut[i], node2: nodeIdUpperStrut[i+1]});
    }

    // Streben
    for (let i=0; i<=(nPf-1); i++) {
        FWMstruts.push({node1: nodeIdLowerStrut[i+1], node2: nodeIdUpperStrut[i]});
    }

    for (let i=nPf; i>0; i--) {
        FWMstruts.push({node1: nodeIdLowerStrut[nodeIdLowerStrut.length-1-i], node2: nodeIdUpperStrut[nodeIdUpperStrut.length-i]});
    }

    // Diagonalen ...
    for (let i=0; i<=nPf; i++) {
        FWMstruts.push({node1: nodeIdLowerStrut[i], node2: nodeIdUpperStrut[i]});
    }

    for (let i=nPf; i>=0; i--) {
        FWMstruts.push({node1: nodeIdLowerStrut[nodeIdLowerStrut.length-1-i], node2: nodeIdUpperStrut[nodeIdUpperStrut.length-i-1]});
    }

    // Nullstäbe bei Querkraftnullpunkt
    let sff = math.floor(xv0 / xSf);
    FWMstruts.push({node1: sff + 1, node2: nodeIdUpperStrut[nPf]});
    FWMstruts.push({node1: sff + 1, node2: nodeIdUpperStrut[nPf + 1]});

    // *** Define supports
    FWMsupports.push({node: 0, dir: 'x'});
    FWMsupports.push({node: 0, dir: 'y'});
    FWMsupports.push({node: nodeIdLowerStrut[nodeIdLowerStrut.length-1], dir: 'y'});

    // *** Define forces...
    for (let i=0; i <= nodeIdUpperStrut.length-1; i++) {

        let qLength = xSf;

        if (i === nPf) {
            qLength = xSfr;
        } else if(i === nPf + 1) {
            qLength = xSfr;
        }

        let force = qLength*q;

        FWMforces.push({node: nodeIdUpperStrut[i], fx: 0, fy: -force});
    }

   // Solve FWM
    let FWMresult = fwSolver(FWMnodes, FWMstruts, FWMsupports, FWMforces);

    //Write result into strut array...
    FWMresult.forEach((res, resKey) => {
        if (resKey < FWMstruts.length) {
            FWMstruts[resKey]['fn'] = res;
        } else {
            FWMsupports[resKey-FWMstruts.length]['f'] = res;
        }
    });

    //**** Plot Fachwerk
    if(vSwitch === 'both' || vSwitch === 'fw'){
        let fwm = new Group();
        FWMstruts.forEach((strut) => {
            if ( strut.fn > 0 ) {
                fwm.addElm(new Line(
                    [FWMnodes[strut.node1].x,FWMnodes[strut.node2].x],
                    [FWMnodes[strut.node1].y,FWMnodes[strut.node2].y]
                ).setDash('dot').setWidth(3).setColor(col.fwm_t.getHex()));
            } else if ( strut.fn < 0 ) {
                fwm.addElm(new Line(
                    [FWMnodes[strut.node1].x,FWMnodes[strut.node2].x],
                    [FWMnodes[strut.node1].y,FWMnodes[strut.node2].y]
                ).setDash('dot').setWidth(3).setColor(col.fwm_c.getHex()));
            } else {
                fwm.addElm(new Line(
                    [FWMnodes[strut.node1].x,FWMnodes[strut.node2].x],
                    [FWMnodes[strut.node1].y,FWMnodes[strut.node2].y]
                ).setDash('dot').setWidth(1).setColor(col.base.getHex()));
            }
        });

        stPlt.addElm(fwm);
    }


    // *********** Generieren der Plotdaten...
    let plt = stPlt.getPlotData();

    // Create Schnittkraft plot...
    let pltData = {
        Data: [
            {
                x: V[0], //Convert from - to micro
                y: V[1], //Convert from N to kN
                mode: 'lines',
                fill: 'tozeroy',
                fillcolor: col.sk_bg.getRgba(),
                line: {
                    color: col.sk.getRgba(),
                    width: 1
                },
                yaxis: 'y2',
            },
            {
                x: x._data,
                y: M._data,
                mode: 'lines',
                fill: 'tozeroy',
                fillcolor: col.sk_bg.getRgba(),
                line: {
                    color: col.sk.getRgba(),
                    width: 1
                },
                yaxis: 'y3',
            }
        ],
        Layout: {
            hovermode: false,
            height: 700,
            margin: {
                l: 60,
                r: 0,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.2, 10.2],
                zeroline: false,
                title: 'x [m]',
            },
            yaxis: {
                range: [-0.3,2.5],
                scaleanchor: 'x',
                domain: [0.6, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                showticklabels: false,
            },
            yaxis2: {
                title: 'V [kN]',
                domain: [0.3, 0.6],
                range: [-550, 550],
            },
            yaxis3: {
                title: 'M [kNm]',
                domain: [0.0, 0.3],
                range: [-1400, 250],
            },
            grid: {
                rows: 3,
                columns: 1,
            },
            showlegend: false
        },
    };
    plt.data.map((item) => {
        item.yaxis = 'y';
    });

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }

    pltData.Data = pltData.Data.concat(plt.data);
    Plotly.react("plotSk", pltData.Data, pltData.Layout, pltConfig);

    // Berechnen der Gurtabschnitte
    let lowerStrut = {
        sectionMid: [],
        sectionWidth: [],
        sectionForce: []
    };

    for (let i=0; i < nodeIdLowerStrut.length-1; i++) {
        lowerStrut.sectionMid.push( (FWMnodes[nodeIdLowerStrut[i]].x+FWMnodes[nodeIdLowerStrut[i+1]].x)/2 );
        lowerStrut.sectionWidth.push( (FWMnodes[nodeIdLowerStrut[i+1]].x-FWMnodes[nodeIdLowerStrut[i]].x) );
        lowerStrut.sectionForce.push( FWMstruts[i].fn );
    }

    let upperStrut = {
        sectionMid: [],
        sectionWidth: [],
        sectionForce: []
    };

    for (let i=0; i < nodeIdUpperStrut.length-1; i++) {
        upperStrut.sectionMid.push( (FWMnodes[nodeIdUpperStrut[i]].x+FWMnodes[nodeIdUpperStrut[i+1]].x)/2 );
        upperStrut.sectionWidth.push( (FWMnodes[nodeIdUpperStrut[i+1]].x-FWMnodes[nodeIdUpperStrut[i]].x) );
        upperStrut.sectionForce.push( FWMstruts[nodeIdLowerStrut.length-1+i].fn );
    }

    let stirrups = {
        sectionMid: [],
        sectionWidth: [],
        sectionForce: []
    };

    for (let i=0; i < nPf; i++) {
        stirrups.sectionMid.push( FWMnodes[nodeIdUpperStrut[i]].x );
        stirrups.sectionWidth.push( xSf );
        stirrups.sectionForce.push( FWMstruts[nodeIdLowerStrut.length+nodeIdUpperStrut.length-2+i].fn );
    }

    for (let i = nPf; i > 0; i--) {
        stirrups.sectionMid.push( FWMnodes[nodeIdUpperStrut[nodeIdUpperStrut.length-i]].x );
        stirrups.sectionWidth.push( xSf );
        stirrups.sectionForce.push( FWMstruts[nodeIdLowerStrut.length+nodeIdUpperStrut.length-2+2*nPf-i].fn );
    }

    // Kontinuierliche Kräfte berechnen...
    var conStrut = {
        sup: [],
        inf: []
    }
    let parallelField, posSup, posInf;
    let dx = x._data[1]-x._data[0];

    // Use x as distance vector
    x.forEach((item, i) => {

        if(i == 0){
            conStrut.sup.push(-(dx/2*q+stirrups.sectionForce[0]/xSf*dx/2));
            conStrut.inf.push(Av*xSf/2/(h-0.2));
        }else{
            //Superior Strut
            //Fächer...
            if(item <= xSf){
                conStrut.sup.push(conStrut.sup[i-1]-(dx*q+stirrups.sectionForce[0]/xSf*dx)*item/(h-0.2));
            } else if(item <= nPf*xSf) {
                parallelField = Math.floor(item/xSf);
                conStrut.sup.push(conStrut.sup[i-1]-(dx*q+stirrups.sectionForce[parallelField]/xSf*dx)/Math.tan(alpha*Math.PI/180));
            }else if(item <= l/2) {
                posInf = (item-nPf*xSf)/(l/2-nPf*xSf)*xSf;
                conStrut.sup.push(conStrut.sup[i-1]-(dx*q)*(item-(nPf-1)*xSf-posInf)/(h-0.2));
            }else if(l-item <= xSf){
                conStrut.sup.push(conStrut.sup[i-1]+(dx*q+stirrups.sectionForce[stirrups.sectionForce.length-1]/xSf*dx)*(l-item)/(h-0.2))
            }else if(l-item <= nPf*xSf){
                parallelField = nPf*2-1-Math.floor(Math.abs(l-item)/xSf);
                conStrut.sup.push(conStrut.sup[i-1]+(dx*q+stirrups.sectionForce[parallelField]/xSf*dx)/Math.tan(alpha*Math.PI/180));
            }else{
                posInf = (l-nPf*xSf-item)/(l/2-nPf*xSf)*xSf;
                conStrut.sup.push(conStrut.sup[i-1]+(dx*q)*(l-nPf*xSf-item+xSf-posInf)/(h-0.2));
            }

            // Inferior Strut
            if(item <= (nPf-1)*xSf){
                parallelField = Math.ceil(item/xSf);
                conStrut.inf.push(conStrut.inf[i-1]+(dx*q+stirrups.sectionForce[parallelField]/xSf*dx)/Math.tan(alpha*Math.PI/180));
            }else if(item <= (nPf*xSf)){
                posSup = (item-(nPf-1)*xSf)/(xSf)*(l/2-nPf*xSf);
                conStrut.inf.push(conStrut.inf[i-1]+(dx/xSf*(l/2-nPf*xSf)*q)*(nPf*xSf+posSup-item)/(h-0.2));
            }else if(l-item <= (nPf-1)*xSf){
                parallelField = nPf*2-1-Math.ceil((l-item)/xSf);
                conStrut.inf.push(conStrut.inf[i-1]-(dx*q+stirrups.sectionForce[parallelField]/xSf*dx)/Math.tan(alpha*Math.PI/180));
            }else if(l-item <= (nPf)*xSf){
                posSup = (nPf*xSf-(l-item))/(xSf)*(l/2-nPf*xSf);
                conStrut.inf.push(conStrut.inf[i-1]-(dx/xSf*(l/2-nPf*xSf)*q)*(item-(l/2+posSup))/(h-0.2));
            }else{
                conStrut.inf.push(conStrut.inf[i-1]);
            }
        }
    });

    // Fachwerkkräfte plotten...

    pltData = {
        Data: [],
        Layout: {
            hovermode: false,
            height: 700,
            margin: {
                l: 60,
                r: 0,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.2, 10.2],
                zeroline: false,
                showgrid: true,
                title: 'x [m]',
            },
            yaxis: {
                range: [-0.3,2.5],
                scaleanchor: 'x',
                domain: [0.6, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                showticklabels: false,
            },
            yaxis2: {
                title: 'Fsup [kN]',
                range: [0, -1200],
                domain: [0.3, 0.6],
            },
            yaxis3: {
                title: 'Finf [kN]',
                range: [0,1200],
                domain: [0.0, 0.3],
            },
            grid: {
                rows: 3,
                columns: 1,
            },
            showlegend: false
        },
    };

    if(vSwitch === 'sp' || vSwitch === 'both'){
        // SP lines...
        pltData.Data.push(
            {
                mode: 'lines',
                x: x._data,
                y: conStrut.sup,
                line: {
                    color: col.forces.getRgba(),
                    width: 2
                },
                yaxis: 'y2'
            }
        );
        pltData.Data.push(
            {
                mode: 'lines',
                x: x._data,
                y: conStrut.inf,
                line: {
                    color: col.forces.getRgba(),
                    width: 2
                },
                yaxis: 'y3'
            }
        );
    }

    if(vSwitch === 'fw' || vSwitch === 'both'){
        pltData.Data.push(
            {
                type: 'bar',
                x: upperStrut.sectionMid,
                y: upperStrut.sectionForce,
                width: upperStrut.sectionWidth,
                marker: {
                    color: col.fwm_c.getRgba(),
                    opacity: 0.6,
                    line: {
                        color: col.base.getRgba(),
                        width: 1
                    }
                },
                yaxis: 'y2'
            }
        );
        pltData.Data.push(
            {
                type: 'bar',
                x: lowerStrut.sectionMid,
                y: lowerStrut.sectionForce,
                width: lowerStrut.sectionWidth,
                marker: {
                    color: col.fwm_t.getRgba(),
                    opacity: 0.6,
                    line: {
                        color: col.base.getRgba(),
                        width: 1
                    }
                },
                yaxis: 'y3'
            }
        );
    }

    // m/z line
    if($('#mzLine').prop("checked")) {

        const mz = math.divide(M, -(h-0.2));
        pltData.Data.push({
            mode: 'lines',
            x: x._data,
            y: mz._data,
            line: {
                color: col.sk.getRgba(),
                width: 2
            },
            yaxis: 'y3'
        });
    }

    pltData.Data = pltData.Data.concat(plt.data);

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }

    Plotly.react("plotFr", pltData.Data, pltData.Layout, pltConfig);

    // Bügelkräfte...
    pltData = {
        Data: [
            {
                type: 'bar',
                x: stirrups.sectionMid,
                y: stirrups.sectionForce,
                width: stirrups.sectionWidth,
                marker: {
                    color: col.fwm_t.getRgba(),
                    opacity: 0.6,
                    line: {
                        color: col.base.getRgba(),
                        width: 1
                    }
                },
                yaxis: 'y2'
            }
        ],
        Layout: {
            hovermode: false,
            height: 700,
            margin: {
                l: 60,
                r: 0,
                b: 60,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.2, 10.2],
                zeroline: false,
                title: 'x [m]',
                showgrid: true,
            },
            yaxis: {
                range: [-0.3,2.5],
                scaleanchor: 'x',
                domain: [0.6, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                showticklabels: false,
            },
            yaxis2: {
                title: 'Fw [kN]',
                range: [0,400],
                domain: [0.3, 0.6],
            },
            /* yaxis3: {
                title: 'Finf [kN]',
                range: [0,1100],
                domain: [0.0, 0.2],
            }, */
            grid: {
                rows: 2,
                columns: 1,
            },
            showlegend: false
        },
    };
    pltData.Data = pltData.Data.concat(plt.data);

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }
    
    Plotly.react("plotFw", pltData.Data, pltData.Layout,  pltConfig);

    /* Live Values */
    document.getElementById('mom').innerHTML = math.round(-math.min(M),0);
    document.getElementById('fa').innerHTML = math.round(Av,0);
    document.getElementById('fsupmin').innerHTML = math.round(math.min(upperStrut.sectionForce),0);
    document.getElementById('finfmax').innerHTML = math.round(math.max(lowerStrut.sectionForce),0);
    document.getElementById('fwmax').innerHTML = math.round(math.max(stirrups.sectionForce),0);
    document.getElementById('finfa').innerHTML = math.round(math.min(lowerStrut.sectionForce),0);

}

/**
 * Function to multiply data by 10^pow. It doesn't matter if data is an integer, double, array or vector from the math library
 * @param data Integer, Double, Array or Vector which elements should be converted
 * @param pow Power (10^pow)
 * @returns {*} Converted input data
 */
function convData(data, pow) {
    if (typeof data === 'object') {
        if (Array.isArray(data)) {
            return data.map(function (value) {
                return value * Math.pow(10, pow);
            });
        } else {
            return math.map(data, function (value) {
                return value * Math.pow(10, pow);
            });
        }
    } else {
        return data * Math.pow(10, pow);
    }

}